<div class="mmr-text-content mmr-min-page-min-height">
  <iframe
    style="width: 100%; height: 1000px"
    src="https://survey.lamapoll.de/2024_mmr_user_survey"
  ></iframe>
</div>
